<template>
  <i class="ph-bold ph-star" />
</template>
